import * as React from "react";

interface RadioProps extends React.ComponentProps<"input"> {
  id: string;
  label: string;
  isChecked?: boolean;
}

function RadioInner(
  props: RadioProps,
  forwardedRef: React.ForwardedRef<HTMLInputElement>
) {
  const { id, label, isChecked, ...rest } = props;

  return (
    <div className="flex items-center">
      <input
        {...rest}
        type="radio"
        className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
        id={id}
        checked={isChecked}
        ref={forwardedRef}
      />
      <label
        htmlFor={id}
        className="ml-3 block text-sm font-medium text-gray-700"
      >
        {label}
      </label>
    </div>
  );
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(RadioInner);

Radio.displayName = "Radio";

export { Radio };
